module.exports = {"en":{"title":"You may be interested in","empty":"No recommendation","loading":"Loading...","buy":"Buy","year":"Year"},"zh":{"title":"域名被注册了？快来域名交易平台看看有没有感兴趣的，就像淘宝一样简单！","empty":"没有可交易的域名","loading":"正在载入...","buy":"立即购买","year":"年"}}


//////////////////
// WEBPACK FOOTER
// ./src/sale/i18n.json
// module id = 148
// module chunks = 0